import { h, createContext } from 'preact';
import { useContext } from 'preact/hooks';
const StoreContext = createContext(null);
export const StoreProvider = ({ children, store }) => {
    return h(StoreContext.Provider, { value: store }, children);
};
export const useStore = () => useContext(StoreContext);
export const withStore = (Component) => (props) => {
    return h(Component, { store: useStore(), ...props });
};
